<template>
  <page v-model:filter="q" :name="$t('Rubrica registranti')" :state="{ contactsState }" :loading="contactsState.updating">
    <template #header>
      {{ $t('I contatti che puoi utilizzare come registranti dei tuoi domini') }}
    </template>

    <template #toolbar-post>
      <pf-toolbar-item>
        <pf-button variant="primary" ouia-id="new-domain-contact" @click="creating = true">
          {{ $t('Nuovo registrante') }}
        </pf-button>
      </pf-toolbar-item>
    </template>

    <pf-page-section>
      <pf-table v-if="filtered.length" striped ouia-id="domain-contacts-table">
        <pf-thead>
          <pf-tr>
            <pf-th
              ><sort-link v-model="s" v-model:reverse="r" field="name">{{ $t('Nome') }}</sort-link></pf-th
            >
            <pf-th
              ><sort-link v-model="s" v-model:reverse="r" field="company">{{ $t('Ragione Sociale') }}</sort-link></pf-th
            >
            <pf-th
              ><sort-link v-model="s" v-model:reverse="r" field="entity_type_label">{{ $t('Tipologia') }}</sort-link></pf-th
            >
            <pf-th
              ><sort-link v-model="s" v-model:reverse="r" field="email">{{ $t('Email') }}</sort-link></pf-th
            >
            <pf-th>{{ $t('Indirizzo') }}</pf-th>
            <pf-th
              ><sort-link v-model="s" v-model:reverse="r" field="reg_code">{{ $t('Codice fiscale / Partita IVA') }}</sort-link></pf-th
            >
            <pf-th
              ><sort-link v-model="s" v-model:reverse="r" field="consent_for_publishing">{{ $t('Consenso') }}</sort-link></pf-th
            >
          </pf-tr>
        </pf-thead>
        <pf-tbody>
          <pf-tr v-for="contact in filtered" :key="contact.id">
            <pf-td :data-label="$t('Nome')">{{ contact.name }}</pf-td>
            <pf-td :data-label="$t('Ragione Sociale')">{{ contact.company }}</pf-td>
            <pf-td :data-label="$t('Tipologia')">{{ contact.entity_type_label }}</pf-td>
            <pf-td :data-label="$t('Email')">{{ contact.email }}</pf-td>
            <pf-td :data-label="$t('Indirizzo')" class="address">
              {{ contact.address }}<br />
              {{ contact.zipcode }} {{ contact.city }} ({{ contact.province }}) {{ contact.country }}
            </pf-td>
            <pf-td :data-label="$t('Codice fiscale / Partita IVA')">{{ contact.reg_code }}</pf-td>
            <pf-td :data-label="$t('Consenso')">{{ contact.consent_label }}</pf-td>
          </pf-tr>
        </pf-tbody>
      </pf-table>

      <pf-empty-state v-else-if="contacts.length">
        <pf-empty-state-header :title="$t('Nessun registrante trovato con il filtro selezionato.')" heading-level="h4">
          <template #icon>
            <magnifying-glass-icon />
          </template>
        </pf-empty-state-header>
      </pf-empty-state>

      <pf-empty-state v-else>
        <pf-empty-state-header :title="$t('Nessun registrante in rubrica')" heading-level="h4">
          <template #icon>
            <address-book-icon />
          </template>
        </pf-empty-state-header>
      </pf-empty-state>
    </pf-page-section>

    <domain-contact-modal v-if="creating" v-model:open="creating" @saved="contactsState.update()" />
  </page>
</template>

<style lang="scss" scoped>
.address {
  white-space: pre-line;
}
</style>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { $t as _t } from '@/i18n';
import { asyncComputedList } from '@common/asyncComputed';
import { any, by } from '@common/utils';
import { DomainContactResource, type DomainContact } from '@/resources';
import SortLink from '../components/sort-link.vue';
import DomainContactModal, { entityTypeLabels } from '../components/domain-contact-modal.vue';
import AddressBookIcon from '@vue-patternfly/icons/address-book-icon';
import MagnifyingGlassIcon from '@vue-patternfly/icons/magnifying-glass-icon';

const { state: contactsState, result: contacts } = asyncComputedList(() => new DomainContactResource().get());

const q = ref(''); // search query
const s = ref<keyof DomainContact | 'entity_type_label'>('name'); // sort by
const r = ref(false); // reverse sort

const filtered = computed(() =>
  contacts.value
    .map(c => ({ ...c, entity_type_label: entityTypeLabels[c.entity_type], consent_label: c.consent_for_publishing ? _t('Sì') : _t('No') }))
    .filter(any(q.value))
    .sort(by(s.value, r.value)),
);

const creating = ref(false);
</script>
